import { Button, useToast } from "@chakra-ui/react";
import useAuthFunctions from "../../hooks/useAuthFunctions";
import { useTranslation } from "react-i18next";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";

const LogoutBtn = () => {
	const { user } = useAuth0();
	const { handleLogout } = useAuthFunctions();
	const { t } = useTranslation();
	const [hovering, setHovering] = useState(false);
	const toast = useToast();

	useEffect(() => {
		let timer: NodeJS.Timeout;

		if (hovering && user?.sub) {
			timer = setTimeout(() => {
				navigator.clipboard.writeText(user.sub);
				toast({
					title: "User ID copied!",
					description: "Your user ID has been copied to the clipboard.",
					status: "info",
					duration: 3000,
					isClosable: true,
				});
			}, 5000);
		} else {
			clearTimeout(timer);
		}

		return () => clearTimeout(timer);
	}, [hovering, user, toast]);

	return (
		<Button
			onClick={handleLogout}
			onMouseEnter={() => setHovering(true)}
			onMouseLeave={() => setHovering(false)}
			colorScheme="red"
			size="sm"
		>
			{t("logout-label")}
		</Button>
	);
};

export default LogoutBtn;
